import React from "react";
import * as Icon from "react-bootstrap-icons";
import { getPostDate } from "../../../utils/date";
import { useSelector } from "react-redux";

const PostContent = ({ post }) => {
  const lang = useSelector((state) => state.mainSlice.lang);
  return (
    <div className="post-content">
      <div className="breadcrumbs mb-2">
        <span className="category">
          {lang === "en"
            ? post.category.name_en
            : lang === "ru"
            ? post.category.name_ru
            : post.category.name_tm}
        </span>
        <Icon.ChevronRight />{" "}
        {lang === "en"
          ? post.name_en.substring(0, 100)
          : lang === "ru"
          ? post.name_ru.substring(0, 100)
          : post.name_tm.substring(0, 100) + " ..."}
      </div>
      <h4 className="title mb-2">
        {lang === "en"
          ? post.name_en
          : lang === "ru"
          ? post.name_ru
          : post.name_tm}
      </h4>
      <div className="date-and-views">
        <span className="date">{getPostDate(post["pub_date"])}</span>
        <span className="views">
          <Icon.Eye /> {post["views"]}
        </span>
      </div>
      <div className="image mb-3">
        {post["image"] !== null && post["image"] !== "" ? (
          <img src={process.env.REACT_APP_API_URL + post["image"]} alt="Post" />
        ) : (
          ""
        )}
      </div>
      <div
        className="content"
        dangerouslySetInnerHTML={{
          __html:
            lang === "en"
              ? post.content_en
              : lang === "ru"
              ? post.content_ru
              : post.content_tm,
        }}
      ></div>
    </div>
  );
};

export default PostContent;
